var render = function () {
  var _vm$ticket, _vm$tariff, _vm$tariff2, _vm$tariff$subscripti, _vm$tariff3, _vm$ticket2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.preview
  }, [_c('base-icon', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 4,
      expression: "4"
    }, {
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "size": 16,
      "name": "arrows_arrow-right"
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }]
  }, [(_vm$ticket = _vm.ticket) !== null && _vm$ticket !== void 0 && _vm$ticket.code ? _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    class: _vm.$style.amount
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayTicketAmount)
    }
  }), _c('span', {
    directives: [{
      name: "m-l",
      rawName: "v-m-l",
      value: 10,
      expression: "10"
    }, {
      name: "f-size",
      rawName: "v-f-size",
      value: '12px',
      expression: "'12px'"
    }, {
      name: "opacity",
      rawName: "v-opacity",
      value: .5,
      expression: ".5"
    }],
    domProps: {
      "textContent": _vm._s("x ".concat(_vm.ticket.count))
    }
  })]) : _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    class: _vm.$style.amount,
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    }
  }), (_vm$tariff = _vm.tariff) !== null && _vm$tariff !== void 0 && _vm$tariff.name ? _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }, {
      name: "f-weight",
      rawName: "v-f-weight",
      value: 700,
      expression: "700"
    }],
    domProps: {
      "textContent": _vm._s(_vm.tariff.name)
    }
  }) : _vm._e(), (_vm$tariff2 = _vm.tariff) !== null && _vm$tariff2 !== void 0 && _vm$tariff2.subscription ? [(_vm$tariff$subscripti = _vm.tariff.subscription) !== null && _vm$tariff$subscripti !== void 0 && _vm$tariff$subscripti.oneTimePayment ? _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    domProps: {
      "textContent": _vm._s(_vm.$t('paid.without.subscription'))
    }
  }) : [_vm.displaySubscriptionTrialDays ? _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    class: _vm.$style.trial,
    domProps: {
      "textContent": _vm._s(_vm.displaySubscriptionTrialDays)
    }
  }) : _vm._e(), _vm.displaySubscriptionPer ? _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    domProps: {
      "textContent": _vm._s(_vm.displaySubscriptionPer)
    }
  }) : _vm._e()]] : _vm._e()], 2), _vm.promoCode ? _c('applied-promo-code-details', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    attrs: {
      "promo-code": _vm.promoCode
    }
  }) : _vm.transactionTips ? _c('applied-transaction-tips', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    attrs: {
      "variant": _vm.transactionTips
    }
  }) : _vm._e(), (_vm$tariff3 = _vm.tariff) !== null && _vm$tariff3 !== void 0 && _vm$tariff3.description ? [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }, {
      name: "cursor",
      rawName: "v-cursor:pointer",
      arg: "pointer"
    }, {
      name: "absolute",
      rawName: "v-absolute"
    }, {
      name: "top",
      rawName: "v-top",
      value: 0,
      expression: "0"
    }, {
      name: "right",
      rawName: "v-right",
      value: 0,
      expression: "0"
    }],
    attrs: {
      "name": "notifications_info"
    },
    on: {
      "click": function click($event) {
        _vm.isShownDescription = !_vm.isShownDescription;
      }
    }
  }), _vm.isShownDescription ? _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 6,
      expression: "6"
    }],
    class: _vm.$style.description,
    domProps: {
      "textContent": _vm._s(_vm.tariff.description)
    }
  }) : _vm._e()] : _vm._e(), (_vm$ticket2 = _vm.ticket) !== null && _vm$ticket2 !== void 0 && _vm$ticket2.link ? _c('div', {
    class: _vm.$style.link
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:black",
      arg: "black"
    }, {
      name: "m-r",
      rawName: "v-m-r",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "size": 16,
      "name": "shopping_coupon"
    }
  }), _c('a', {
    directives: [{
      name: "color",
      rawName: "v-color:text",
      arg: "text"
    }, {
      name: "text-decoration",
      rawName: "v-text-decoration:underline",
      arg: "underline"
    }],
    attrs: {
      "href": _vm.ticket.link,
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('bill.ticket'))
    }
  })], 1) : _vm.contentUrl ? _c('div', {
    class: _vm.$style.url
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:black",
      arg: "black"
    }, {
      name: "m-r",
      rawName: "v-m-r",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "size": 16,
      "name": "basic_paperclip"
    }
  }), _c('a', {
    directives: [{
      name: "color",
      rawName: "v-color:text",
      arg: "text"
    }, {
      name: "text-decoration",
      rawName: "v-text-decoration:underline",
      arg: "underline"
    }],
    attrs: {
      "href": _vm.contentUrl,
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('realised.content'))
    }
  })], 1) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }